module.exports = __webpack_public_path__ + "static/work-2-77ca88c3fa9300c5568d88b89e824587.png";